//export const Servidor = 'https://www.grupoaressa.com:12622/api/';
export const Servidor = 'https://desofiw.xyz:12642/api/';

//export const Servidor = 'http://localhost:12621/api/';
//export const ServidorArchivos = 'https://storage.googleapis.com/archivos_desofiw/';
export const UsuarioIniciarSesion = 'usuarios/iniciarsesion';
export const UsuarioEnviarPin = 'usuarios/pin';
export const UsuarioActualizarContrasena = 'usuarios/actualizar/contrasena';
//clientes
export const ClientesGuardar = Servidor + 'clientes/guardar';
export const ClientesGuardar2 = Servidor + 'clientes/guardar/auto';
export const ClientesEditar = Servidor + 'clientes/editar?id=';
export const ClienteListar = Servidor + 'clientes/listar';
export const ClienteEliminar = Servidor + 'clientes/eliminar?id='; 
//ver imagen
export const ImagenCliente = Servidor + 'imagenes/clientes/';
export const ImagenEmpleado = Servidor + 'imagenes/empleados/';
export const ImagenProducto = Servidor + 'imagenes/productos/';
export const ImagenServicio = Servidor + 'imagenes/servicios/';
export const ImagenTipoProducto = Servidor + 'imagenes/productos/categorias/';
export const ImagenTipoServicio = Servidor + 'imagenes/servicios/categorias/';
//editar archivos
export const EmpleadoImagenEditar = Servidor + 'archivos/imagen/empleado?id=';
export const ClienteImagenEditar = Servidor + 'archivos/imagen/cliente?id=';
//empleados
export const EmpleadosGuardar = Servidor + 'empleados/guardar';
export const EmpleadosEditar = Servidor + 'empleados/editar?id=';
export const EmpleadosPerfilEditar = Servidor + 'empleados/perfil/editar?id=';
export const EmpleadosListar = Servidor + 'empleados/listar';
export const EmpleadosEliminar = Servidor + 'empleados/eliminar';
export const EmpleadoId = Servidor + 'empleados/buscarid?id=';
export const EmpleadoFiltro = Servidor + 'empleados/buscarfiltro?filtro=';
//cargos
export const CargosListar = Servidor + 'cargos/listar';
export const CargosGuardar = Servidor + 'cargos/guardar';
export const CargosEditar = Servidor + 'cargos/editar?id=';
export const CargosEliminar = Servidor + 'cargos/eliminar?id=';
export const CargoId = Servidor + 'cargos/buscarid?id=';
export const CargoNombre = Servidor + 'cargos/buscarnombre?nombre=';
//Productos
export const ProductosListar = Servidor + 'productos/listar';
export const ProductosListar2 = Servidor + 'productos/listar2';
export const ProductosListarVenta = Servidor + 'productos/listarventa';
export const ProductosBuscarId = Servidor + 'productos/buscarid';
export const ProductosBuscarNombre = Servidor + 'productos/BuscarPorNombre';
export const ProductoBuscarTipo = Servidor + 'productos/buscartipo';
export const ProductoListarBajo = Servidor + 'productos/bajo-reorden';
//Pedidos
export const PedidosListarClienteId = Servidor + 'pedidos/listar/clienteid';
export const PedidosListarEmpleadoId = Servidor + 'pedidos/listar/empleadoid';
export const PedidosListarEstadoClienteId = Servidor + 'pedidos/listarEstado/clienteid';
export const PedidosListarEstadoEmpleadoId = Servidor + 'pedidos/listarEstado/empleadoid';
export const PedidosListar = Servidor + 'pedidos/listar';
export const PedidosGuardar = Servidor + 'pedidos/guardar';
export const PedidosEditar = Servidor + 'pedidos/editar';
export const PedidosEliminar = Servidor + 'pedidos/eliminar?id=';
export const PedidosFiltro = Servidor + 'pedidos/listarFiltro';
export const PedidosId = Servidor + 'pedidos/id?id=';
//productos
export const ProductosGuardar = Servidor + 'productos/guardar';
export const ProductosEditar = Servidor + 'productos/editar?id=';
export const ProductosLotesEditar = Servidor + 'productos/editar/lotes?id=';
export const ProductosConLotesEditar = Servidor + 'productos/editar/producto/lotes?id=';
export const ProductosEditarImagenes = Servidor + 'productos/editar-imagenes?id=';
export const ProductosEliminar = Servidor + 'productos/eliminar?id=';
export const ProductosId = Servidor + 'productos/buscarid?id=';
export const ProductosNombre = Servidor + 'productos/BuscarPorNombre?nombre=';
export const ProductosCodigo = Servidor + 'productos/BuscarPorCodigo?codigo=';
export const ProductosFiltro = Servidor + 'productos/buscarfiltro?filtro=';
export const ProductosCalcularImpuesto = Servidor + 'productos/calcularimpuesto';
//Tipos de productos
export const ProductosTiposGuardar = Servidor + 'productos/tipos/guardar';
export const ProductosTiposEditar = Servidor + 'productos/tipos/editar?id=';
export const ProductosTiposEliminar = Servidor + 'productos/tipos/eliminar?id=';
export const ProductosTiposId = Servidor + 'productos/buscarid?id=';
export const ProductosTiposListar = Servidor + 'productos/tipos/listar';
// Bancos(Cuentas pos y transferencia)
export const BancosListar = Servidor + 'bancos/listar';
export const BancosId = Servidor + 'bancos/buscarid?id=';
//Facturacion
export const FacturacionGuardar = Servidor + 'facturacion/guardar';
export const VentaGuardar = Servidor + 'ventas/guardar';
export const VentaListar = Servidor + 'ventas/listar';
export const VentaListarId = Servidor + 'ventas/imprimirVentaId?id=';
export const VentaAnulada = Servidor + 'ventas/ventanulada';
export const VentaPagoAnulada = Servidor + 'ventas/pagoAnulado';
export const VentaPagoNuevo = Servidor + 'ventas/pagoNuevo';
export const VentaPagaCredito = Servidor + 'ventas/pagarCredito';
export const VentaListarPagos = Servidor + 'ventas/listarpagos';
export const VentaFiltro = Servidor + 'ventas/listarFiltro';
export const VentaAnalisis = Servidor + 'ventas/analisis/ventas-periodicas';
export const VentaTopClientes = Servidor + 'ventas/analisis/top-clientes';
export const VentaTopFrecuenciaClientes = Servidor + 'ventas/analisis/top-frecuencia-clientes';
export const VentaTopProductos = Servidor + 'ventas/analisis/ranking-productos';
export const VentaTopProductosMenosVendidos = Servidor + 'ventas/analisis/ranking-productos-menos-vendidos';
export const VentaRentabilidadProductos = Servidor + 'ventas/analisis/rentabilidad-productos';
export const VentaComparacionTipo = Servidor + 'ventas/comparacionTipo';
export const VentaComparacionMetodoPago = Servidor + 'ventas/comparacionMetodoPago';
export const VentaCreditoPendiente = Servidor + 'ventas/creditoPendientes';
//Analisis
export const AnalisisVentasPeriodicas = Servidor + 'analisis/ventas-periodicas';
export const AnalisisTopClientes = Servidor + 'analisis/top-clientes';
export const AnalisisTopFrecuenciaClientes = Servidor + 'analisis/top-frecuencia-clientes';
export const AnalisisResumenKPICliente = Servidor + 'analisis/resumen-metrica-kpi-clientes';
export const AnalisisMoraCliente = Servidor + 'analisis/mora-antiguedad';
export const AnalisisTopProductos = Servidor + 'analisis/ranking-productos';
export const AnalisisTopProductosMenosVendidos = Servidor + 'analisis/productos-menos-vendidos';
export const AnalisisRentabilidadProductos = Servidor + 'analisis/rentabilidad-productos';
export const AnalisisResumenKPIProducto = Servidor + 'analisis/resumen-metrica-kpi-productos';
export const AnalisisComparacionStock = Servidor + 'analisis/comparacion-stock';
export const AnalisisRotacionProductos = Servidor + 'analisis/rotacion-diaria-producto';
export const AnalisisComparacionTipo = Servidor + 'analisis/comparacionTipo';
export const AnalisisComparacionMetodoPago = Servidor + 'analisis/comparacionMetodoPago';
export const AnalisisCreditoPendiente = Servidor + 'analisis/creditoPendientes';
export const AnalisisResumenKPIEmpleado = Servidor + 'analisis/resumen-metrica-kpi-empleados';
export const AnalisisTopEmpleados = Servidor + 'analisis/top-empleados-ventas';
export const AnalisisTopEmpleadosPedidos = Servidor + 'analisis/top-empleados-pedidos';
export const AnalisisTendenciasEmpleados = Servidor + 'analisis/tendencia-actividad';
export const AnalisisAlertasPendientes = Servidor + 'analisis/alertas-pendientes';
export const AnalisisErroresRecientes = Servidor + 'analisis/errores-recientes';
export const AnalisisResumenKPIVentas = Servidor + 'analisis/resumen-metricas-kpi-ventas';
export const AnalisisMetodosPagosVentas = Servidor + 'analisis/metodos-pago-ventas';
export const AnalisisEvolucionVentas = Servidor + 'analisis/evolucion-ventas';
export const AnalisisMoraVentas = Servidor + 'analisis/mora-ventas';
export const AnalisisResumenKPICompras = Servidor + 'analisis/resumen-metricas-kpi-compras';
export const AnalisisMetodosPagosCompras = Servidor + 'analisis/metodos-pago-compras';
export const AnalisisEvolucionCompras = Servidor + 'analisis/evolucion-compras';
export const AnalisisMoraCompras = Servidor + 'analisis/proveedores-mora';
export const AnalisisResumenKPICajas = Servidor + 'analisis/resumen-metricas-kpi-cajas';
export const AnalisisDesgloseGastosCajas = Servidor + 'analisis/desglose-gastos-cajas';
export const AnalisisDesgloseMetodoCajas = Servidor + 'analisis/desglose-metodo-pago-cajas';
export const AnalisisTendenciaDiariaCajas = Servidor + 'analisis/tendencia-diaria-cajas';
export const AnalisisEstadoCajas = Servidor + 'analisis/estado-cajas';   
export const AnalisisAuditoriaCajas = Servidor + 'analisis/auditoria-cierres-cajas';
//Caja
export const DenominacionListar = Servidor + 'denominaciones/listar';
export const AperturaGuardar = Servidor + 'denominaciones/guardarApertura';
export const CierreGuardar = Servidor + 'denominaciones/guardarCierre';
export const UltimaApertura = Servidor + 'denominaciones/ultima';
export const CajaVerificar = Servidor + 'cajas/verificar';
export const CajaHabilitar = Servidor + 'cajas/habilitarcaja';
export const CajaAutenticacion = Servidor + 'cajas/autenticacion';
export const CajaVerificada = Servidor + 'estacion/detalle';
export const AperturaListar = Servidor + 'cajas/listarapertura';
export const CierreListar = Servidor + 'cajas/listarcierre';
export const CargaCierre = Servidor + 'cajas/autenticacioncierre';
//Accesos
export const AccesosListar = Servidor + 'accesos/listar';
export const AccesosGuardar = Servidor + 'accesos/guardar';
export const AccesosEliminar = Servidor + 'accesos/eliminar?id=';
export const AccesosEditar = Servidor + 'accesos/editar?id=';
//Usuarios
export const UsuariosEmpleadosListar = Servidor + 'usuarios/empleados';
//Proveedores
export const ProveedoresListar = Servidor + 'proveedores/listar';
export const ProveedoresGuardar = Servidor + 'proveedores/guardar';
export const ProveedoresEditar = Servidor + 'proveedores/editar?id=';
export const ProveedoresEliminar = Servidor + 'proveedores/eliminar?id=';
//Compras
export const ComprasListar = Servidor + 'compras/listar';
export const ComprasGuardar = Servidor + 'compras/guardar';
export const ComprasEditar = Servidor + 'compras/editar?id=';
export const CompraListarId = Servidor + 'compras/imprimirCompraId?id=';
export const ComprasAnulada = Servidor + 'compras/compranulada';
export const CompraPagoAnulada = Servidor + 'compras/pagoAnulado';
export const CompraPagaCredito = Servidor + 'compras/pagarCredito';
export const ComprasListarPagos = Servidor + 'compras/listarpagos';
export const CompraFiltro = Servidor + 'compras/listarFiltro';
//Creditos
export const CreditoVencidoCompras = Servidor + 'compras/creditoVencidos';
export const CreditoVencidoVentas = Servidor + 'ventas/creditoVencidos';
//Inventarios
export const InventariosListar = Servidor + 'inventarios/listar';
export const InventariosGuardar = Servidor + 'inventarios/guardar';
export const InventariosAnulado = Servidor + 'inventarios/inventarioanulado';
export const InventariosTiposListar = Servidor + 'inventarios/tipos/listar';
export const InventariosTiposGuardar = Servidor + 'inventarios/tipos/guardar';
export const InventariosTiposEditar = Servidor + 'inventarios/tipos/editar?id=';
export const InventariosTiposEliminar = Servidor + 'inventarios/tipos/eliminar?id=';
export const InventariosExistencia = Servidor + 'inventarios/existencias';
export const InventariosRotacion = Servidor + 'ventas/rotacion';
//Lotes
export const LotesInventarioListar = Servidor + 'lotes/inventario/listar';
export const LotesInventarioGuardar = Servidor + 'lotes/inventario/guardar';
export const LotesInventarioEditar = Servidor + 'lotes/inventario/editar?id=';
export const LotesInventarioEliminar = Servidor + 'lotes/inventario/eliminar?id=';
//Promociones
export const PromocionesListar = Servidor + 'promociones/listar';
export const PromocionesGuardar = Servidor + 'promociones/guardar';
export const PromocionesEditar = Servidor + 'promociones/editar';
export const PromocionesEliminar = Servidor + 'promociones/eliminar';
//Cotizaciones
export const CotizacionesListarClienteId = Servidor + 'cotizaciones/listar/clienteid';
export const CotizacionesListarEmpleadoId = Servidor + 'cotizaciones/listar/empleadoid';
export const CotizacionesmpleadoId = Servidor + 'cotizaciones/listar/empleadoid';
export const CotizacionesListarEstadoClienteId = Servidor + 'cotizaciones/listarEstado/clienteid';
export const CotizacionesListarEstadoEmpleadoId = Servidor + 'cotizaciones/listarEstado/empleadoid';
//export const CotizacionesListar = Servidor + 'cotizaciones/listar';
export const CotizacionesGuardar = Servidor + 'cotizaciones/guardar';
export const CotizacionesEditar = Servidor + 'cotizaciones/editar';
export const CotizacionesEliminar = Servidor + 'cotizaciones/eliminar?id=';
export const CotizacionesFiltro = Servidor + 'cotizaciones/listarFiltro';
export const CotizacionId = Servidor + 'cotizaciones/id?id=';
//Estacion
export const EstacionGuardar = Servidor + 'estaciones/guardar';
export const EstacionBuscar = Servidor + 'estaciones/buscarnombre?nombre=';
//IngresosEgresos
export const IngresosEgresosGuardar = Servidor + 'ingresos/egresos/guardar';
export const IngresosEgresosListar = Servidor + 'ingresos/egresos/listar';


//Planillas y Nómina
export const PlanillasPeriodosListar = Servidor + 'planillas/periodos';
export const PlanillasGenerar = Servidor + 'planillas/generar';
export const PlanillasDetalle = Servidor + 'planillas/'; // :id/detalle
export const PlanillasAprobar = Servidor + 'planillas/'; // :id/aprobar
export const PlanillasReciboEmpleado = Servidor + 'planillas/empleado/'; // :empleadoId/recibo/:periodoId
export const EmpleadosConfiguracionLaboral = Servidor + 'empleados/configuracion-laboral';
export const EmpleadosPrestamos = Servidor + 'empleados/prestamos';

// Dashboard Operativo por Empleado
export const DashboardEmpleadoResumen = Servidor + 'dashboard/empleado-resumen';
